module.exports = __webpack_public_path__ + "static/img/speed-stop.f645847d.png";